import {ConversationType} from '@toolify/server/src/models/mongoose/MessageModel/enum/ConversationType'
import {IConversationTypeInterfacesMap} from '@toolify/server/src/services/MessageService/types/IConversationTypeInterfacesMap'
import {useWorkspaceConversationTypeStrategy} from './useWorkspaceConversationTypeStrategy'
import {useDatabaseCellConversationTypeStrategy} from './useDatabaseCellConversationTypeStrategy'
import {useDatabaseFileConversationTypeStrategy} from './useDatabaseFileConversationTypeStrategy'
import {useCloudFileConversationTypeStrategy} from './useCloudFileConversationTypeStrategy'
import {useDirectConversationTypeStrategy} from './useDirectConversationTypeStrategy'
import {useCallRoomConversationTypeStrategy} from './useCallRoomConversationTypeStrategy'

type AnyConversationPayload = IConversationTypeInterfacesMap[ConversationType]['conversationTypePayload']

export function useConversationTypeStrategy(conversationType: ConversationType) {
  const workspaceStrategy = useWorkspaceConversationTypeStrategy
  const databaseCellStrategy = useDatabaseCellConversationTypeStrategy
  const databaseFileStrategy = useDatabaseFileConversationTypeStrategy
  const cloudFileStrategy = useCloudFileConversationTypeStrategy
  const directStrategy = useDirectConversationTypeStrategy
  const callRoomStrategy = useCallRoomConversationTypeStrategy

  const strategyMap = {
    [ConversationType.Workspace]: workspaceStrategy,
    [ConversationType.DatabaseCell]: databaseCellStrategy,
    [ConversationType.DatabaseFile]: databaseFileStrategy,
    [ConversationType.CloudFile]: cloudFileStrategy,
    [ConversationType.Direct]: directStrategy,
    [ConversationType.CallRoom]: callRoomStrategy,
  }

  const defaultGetConversationKey = (_payload: AnyConversationPayload): string | null => null

  if (!strategyMap[conversationType]) {
    return {
      getConversationKey: defaultGetConversationKey,
      getRelayConversationKey: defaultGetConversationKey,
    }
  }
  const strategy = strategyMap[conversationType]()
  return {
    getConversationKey: strategy.getConversationKey ?? defaultGetConversationKey,
    getRelayConversationKey: strategy.getRelayConversationKey ?? defaultGetConversationKey,
  }
}
